import axios from "axios";

const finnotech = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getBalance() {
            let response = await axios.get(`/get_balance`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getWallet(context, payload) {
            let response = await axios.get(`/get_wallet/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async getBalanceByAccountNumber(content, payload) {
            let response = await axios.get(`/get_balance_by_account_number/${payload}`);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async instancePayment(context, payload) {
            let response = await axios.post(`/instance_payment`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async mainAccountTransferTo(context, payload) {
            let response = await axios.post(`/main_account_transfer_to`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async walletAccountTransferTo(context, payload) {
            let response = await axios.post(`/wallet_account_transfer_to`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async increaseWallet(context, payload) {
            let response = await axios.post(`/increase_wallet_money`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async updateWalletMoney(context, payload) {
            let response = await axios.post(`/update_wallet_money`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async sendFinnotechSms(context, payload) {
            let response = await axios.post('/send_finnotech_sms',payload)
            if (response.status === 200) {
                return response;
            }
        },
        async getTransactions(context, payload) {
            let response = await axios.get(`/get_last_statements/${payload}`)
            if (response.status === 200) {
                return response;
            }
        },
        async getCardInfo(context, payload) {
            let response = await axios.get(`/get_card_info/${payload}`)
            if (response.status === 200) {
                return response;
            }
        },
        async getIbanInfo(context, payload) {
            let response = await axios.get(`/get_iban_info/${payload}`)
            if (response.status === 200) {
                return response;
            }
        },

    },
    getters: {}
}

export default finnotech;
